/**
 * @author alteredq / http://alteredqualia.com/
 *
 * Full-screen textured quad shader
 */

var blitShader = {
  uniforms: {
    tDiffuse: { value: null },
    opacity: { value: 1.0 },
    tTexture: { value: null }
  },

  vertexShader: [
    'varying vec2 vUv;',

    'void main() {',

    '	vUv = uv;',
    '	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',

    '}'
  ].join('\n'),

  fragmentShader: [
    'uniform float opacity;',

    'uniform sampler2D tDiffuse;',
    'uniform sampler2D tTexture;',

    'varying vec2 vUv;',

    'void main() {',

    '	vec4 texel = texture2D( tTexture, vUv );',
    '	gl_FragColor = vec4(texel.xyz, 1.0);',
    '}'
  ].join('\n')
}

export { blitShader }
